import withGtmPageType from 'apps/gtm/utils/gtmPageType/withGtmPageType';
import PromoBoxInMainContainer from '../components/PromoBoxInMainContainer';

export default withGtmPageType(PromoBoxInMainContainer);
